import { defineMessages } from "react-intl";

export const datasetMessages = defineMessages({
  public: { defaultMessage: "Public" },
  publicButton: { defaultMessage: "Make public" },
  publicExplanation: {
    defaultMessage:
      "Anyone can view this dataset. Only you or your team can make changes.",
  },
  private: { defaultMessage: "Private" },
  privateButton: { defaultMessage: "Make private" },
  privateExplanation: {
    defaultMessage: "Only you or your team can view and edit this dataset.",
  },
});
